module.exports = __webpack_public_path__ + "media/images/online/plan-detail-background-long-084780bff2d71514c02a29da281b4ced.jpg";